import React from 'react'
import {Grid} from '@mui/material'
import {SystemStyleObject} from "@mui/system/styleFunctionSx/styleFunctionSx";
import {Theme} from "@mui/material/styles";

type Props = {
    children: any
    spacing?: number
    sx?: | SystemStyleObject<Theme> | ((theme: Theme) => SystemStyleObject<Theme>)
}

export default function FormRow({ children, spacing, sx }: Props) {
    return (
        <Grid container item spacing={spacing || 3} sx={sx || {}}>
            {children}
        </Grid>
    )
}
